const Title = (props) => {
  const mainTitleHeight = props.height * 0.5;
  const subTitleHeight = (props.height - mainTitleHeight);

  const content = {
    drc: {
      title: "Democratic Republic of the Congo",
      subtitle: "Re-elected President Tshisekedi Faces Regional Crisis in the East",
    },
    haiti: {
      title: "Haiti",
      subtitle: "Gangs and Vigilantes Thrive Amid Political Deadlock",
    },
    myanmar: {
      title: "Myanmar",
      subtitle: "Continued Opposition to the Junta Amid Increasing Civilian Targeting by the Military",
    },
    nigeria: {
      title: "Nigeria",
      subtitle: "Historic Elections Threatened by Insecurity ",
    },
    ukraine: {
      title: "Ukraine",
      subtitle: "A Deadly Stalemate with No End in Sight",
    },
    yemen: {
      title: "Yemen",
      subtitle: "Rising Tensions Threaten Peace Process and International Security",
    },
    usa: {
      title: "United States",
      subtitle: "Intensifying Polarization and the Looming Presidential Election",
    },
    palestine: {
      title: "Palestine",
      subtitle: "An Uncertain Future for Gaza and the West Bank",
    },
    sudan: {
      title: "Sudan",
      subtitle: "Setting the Stage for a Long War",
    },
    mexico: {
      title: "Mexico",
      subtitle: "Confronting Deadly Political and Criminal Power Struggles in an Election Year",
    },
    sahel: {
      title: "Sahel",
      subtitle: "A Deadly New Era in the Decades-Long Conflict",
    },
  };

  return (
    <div
      id="titleContainer"
      className="container"
      style={{
        height: props.height,
        width: props.width,
        margin: "auto",
        background: "#ededed",
      }}
    >
      <div
        id="mainTitle"
        className="text-white titleSection"
        style={{ height: mainTitleHeight, background: "#12425e" }}
      >
        <h2>Conflict Watchlist 2023: <strong>{content[props.focusCountry].title}</strong></h2>
      </div>
      <div
        id="subTitle"
        className="titleSection"
        style={{ height: subTitleHeight, background: "#f0f0f0" }}
      >
        <p>{content[props.focusCountry].subtitle}</p>
      </div>
      {/* <div
        id="date"
        className="titleSection"
        style={{ height: subTitleHeight, background: "#ffffff" }}
      >
        <p>10 January - 30 June 2022</p>
      </div> */}
    </div>
  );
};

export default Title;
